import { OPEN_ENTRY_DIALOG } from '../actions/dialogAction';
export const dialogState = {
    open_entry_dialog: false,
    type: 'signin',
};
export const dialogReducer = (state = dialogState, action) => {
    switch (action.type) {
        case OPEN_ENTRY_DIALOG:
            return { ...state, open_entry_dialog: action.data.open, type: action.data.type };
        default:
            return state;
    }
};
